import { render, staticRenderFns } from "./FormatReferencesSelector.vue?vue&type=template&id=d13c3402&scoped=true&"
import script from "./FormatReferencesSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatReferencesSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferencesSelector.vue?vue&type=style&index=0&id=d13c3402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13c3402",
  null
  
)

export default component.exports